import React from 'react';
import {
  HomeOutlined,
  TeamOutlined,
  FileTextOutlined,
  SafetyOutlined,
  UserOutlined,
  LogoutOutlined,
  PlusOutlined,
  AppstoreOutlined,
  ReloadOutlined,
  DesktopOutlined,
  KeyOutlined,
  BellOutlined,
  AuditOutlined,
  InboxOutlined,
  ApiOutlined,
  CloudServerOutlined,
  InfoCircleOutlined,
} from '@ant-design/icons';

type IconProps = { w?: number | string; h?: number | string };

function size(p?: IconProps) {
  const n = Number(p?.w ?? p?.h ?? 18);
  return { fontSize: n };
}

function SvgIcon({ d, p }: { d: React.ReactNode; p?: IconProps }) {
  const n = Number(p?.w ?? p?.h ?? 18);
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={n} height={n} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      {d}
    </svg>
  );
}

export const Icons = {
  Home: (p?: IconProps) => <HomeOutlined style={size(p)} />,
  Users: (p?: IconProps) => <TeamOutlined style={size(p)} />,
  Plan: (p?: IconProps) => <FileTextOutlined style={size(p)} />,
  Audit: (p?: IconProps) => <AuditOutlined style={size(p)} />,
  Shield: (p?: IconProps) => <SafetyOutlined style={size(p)} />,
  User: (p?: IconProps) => <UserOutlined style={size(p)} />,
  LogOut: (p?: IconProps) => <LogoutOutlined style={size(p)} />,
  Plus: (p?: IconProps) => <PlusOutlined style={size(p)} />,
  Layers: (p?: IconProps) => <AppstoreOutlined style={size(p)} />,
  Monitor: (p?: IconProps) => <DesktopOutlined style={size(p)} />,
  Refresh: (p?: IconProps) => <ReloadOutlined style={size(p)} />,
  Bell: (p?: IconProps) => <BellOutlined style={size(p)} />,
  Key: (p?: IconProps) => <KeyOutlined style={size(p)} />,
  Api: (p?: IconProps) => <ApiOutlined style={size(p)} />,
  CloudServer: (p?: IconProps) => <CloudServerOutlined style={size(p)} />,
  ChevronDown: (p?: IconProps) => (
    <SvgIcon p={p} d={<polyline points="6 9 12 15 18 9" />} />
  ),
  Payment: (p?: IconProps) => (
    <SvgIcon p={p} d={<><rect x="1" y="4" width="22" height="16" rx="2" /><line x1="1" y1="10" x2="23" y2="10" /></>} />
  ),
  Zap: (p?: IconProps) => (
    <SvgIcon p={p} d={<polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />} />
  ),
  Empty: () => <InboxOutlined style={{ fontSize: 56, opacity: 0.3 }} />,
  Info: (p?: IconProps) => <InfoCircleOutlined style={size(p)} />,
};
